import React from 'react';
import { SegmentedControl, SegmentedControlProps } from '@mantine/core';

export function ESegmentedControl({ ...props }: SegmentedControlProps) {
    return (
        <SegmentedControl
            transitionDuration={200}
            transitionTimingFunction="linear"
            {...props}
        />
    )
}
